import React, { useMemo } from 'react';
import Certain from "../../../../components/Operation/Certain";
import Delay from "../../../../components/Operation/Delay";
import Duration from "../../../../components/Operation/Duration";
import FishDisease from "../../../../components/Operation/FishDisease";
import Id from "../../../../components/Operation/Id";
import LiceList from "../../../../components/Operation/LiceList";
import Logo from "../../../../components/Operation/Logo";
import NameSpot from "../../../../components/Operation/NameSpot";
import NoteDetail from "../../../../components/Operation/NoteDetail";
import OperationStatus from "../../../../components/Operation/OperationStatus";
import TaskNoteDetail from "../../../../components/Operation/TaskNoteDetail";
import Weather from "../../../../components/Operation/Weather";
import { useOperation } from '../../../../contexts/OperationContext';
import { OP_STATUS, OPERATION_TYPE, serviceTask } from "../../../../util/varibles/constants";
import { IOperation, IService, TOperation2 } from "../../../../util/varibles/interface";
import styles from "./style.module.scss";

interface IProps {
    data: IOperation
    isOwn: boolean
    status: OP_STATUS
}

const ServiceView: React.FC<IProps> = ({ data, isOwn, status }) => {
    const { activity_log, operation } = data;
    const { tasks = [] } = operation as IService;
    const [realStatus = status] = useOperation(state => state.realStatus);
    const { locations, taskNames } = useMemo(() => tasks.reduce((rs: {
        locations: { [id: string]: { name: string, subs: string[] } },
        taskNames: { [id: string]: string }
    }, item) => {
        const { location_id, location_name, type, sub_operations = [], name } = item;
        if (location_id) {
            if (!rs.locations[location_id])
                rs.locations[location_id] = {
                    name: location_name,
                    subs: []
                }
            rs.locations[location_id].subs = Array.from(new Set([...rs.locations[location_id].subs, ...sub_operations.map(item => item.unit_id)]));
        }
        if (type)
            rs.taskNames[type] = name ?? serviceTask[type]?.name
        return rs;
    }, { locations: {}, taskNames: {} }), [tasks]);

    return <>
        <div className={styles.title}>
            <div className={styles.left}>
                <Logo type={OPERATION_TYPE.SERVICE} status={realStatus} />
                <Id operation={operation} status={realStatus} />
                <OperationStatus status={realStatus} />
                <Certain operation={operation} status={status} />
                <div className='leading-[20px]'>
                    {Object.keys(locations).map(key => {
                        const value = [locations[key].name];
                        if (locations[key].subs.length > 0)
                            value.push(locations[key].subs.join(', '));
                        return value.join(' - ');
                    }).join('; ')}
                </div>
            </div>
            <div className={styles.right}>
                <FishDisease diseases={operation.diseases} units={operation.sub_operations} short={true} />
                <Weather {...{ visible: true, operation: operation as TOperation2 }} />
                <Delay visible={true} operation={operation} />
                {!isOwn && <NameSpot {...{ visible: true, operation }} />}
            </div>
        </div>
        <FishDisease diseases={operation.diseases} units={operation.sub_operations} wrapperClass={styles.section} />
        <LiceList diseases={operation.diseases} short wrapperClass={styles.section} />
        <div className={styles.section}>
            <div className='leading-[20px]'>
                {Object.keys(taskNames).map(key => taskNames[key]).join(', ')}
            </div>
            <Duration {...{ visible: true, status, activity_log }} more={false} />
        </div>
        <TaskNoteDetail tasks={tasks} />
        <NoteDetail operation={operation} visible={true} />
    </>;
};

export default ServiceView;
